import SitemapViewerContainer from "../features/sitemap/SitemapViewer";

const SitemapViewer = () => <SitemapViewerContainer />;

export default SitemapViewer;
